import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Notification } from '@unified-checkout/design-system';
import { Lock } from '@unified-checkout/design-system/icons/index';
import { DeviceContext } from '../../../context/device';
import { INNER_ROUTES } from '../../../constants';

type PasskeyAnnouncementProps = {
  onClose: () => void;
};
export const PasskeyAnnouncement = ({
  onClose
}: PasskeyAnnouncementProps) => {
  const { isMobile } = useContext(DeviceContext);
  const navigate = useNavigate();
  return (
    <Notification
      isMobile={isMobile}
      icon={Lock}
      hasCloseIcon
      title="Setup your passkey"
      hintText="Enjoy fast checkouts with passkeys"
      show
      btnsProps={[
        {
          text: 'Not now',
          size: 'md',
          variant: 'link',
          color: 'secondary',
          onClickHandler: onClose,
        },
        {
          text: 'Setup passkey',
          color: 'primary',
          variant: 'link',
          onClickHandler: () => {
            navigate(INNER_ROUTES.PASSKEYS);
            onClose();

          },
        },
      ]}
    />
  );
};
